import { OffersDimensionTextComponent } from './offers-dimension-text.component';

import { runClientComponent } from '../../_common/client/client-component-runner';

runClientComponent({ offersDimensionText: OffersDimensionTextComponent });
